import React from 'react'

import { useQuizContext } from 'store/QuizStore'
import { setScreen } from 'store/actions'
import { FluidBox, NavButton } from 'styled'

import { Root, ContentBox, ResultBox, ResultCircle } from './ResultMessage.styled.js'

import messages from './messages'

const calcResult = (questions, answers) => {
  let r = 0
  questions.forEach((question, id) => {
    if (question.correct === answers[id]) {
      r++
    }
  })
  return r
}

const msgMap = {
  7: 0,
  6: 0,
  5: 1,
  4: 1,
  3: 1,
  2: 2,
  1: 2,
  0: 3,
}

const ResultMessage = () => {
  const { questions, answers, numQuestions, dispatch } = useQuizContext()
  const result = calcResult(questions, answers)

  return (
    <Root pt={[40, 40, 40, 80]}>
      <ContentBox pr={[20, 40, 40, 240]}>
        <ResultBox pb="spaceLarge" mb="spaceLarge">
          <ResultCircle fs="textXl" mr="spaceSmall">
            {result}/{numQuestions}
          </ResultCircle>
          <FluidBox fs="textLarge">{messages[msgMap[result]].title}</FluidBox>
        </ResultBox>
        <FluidBox lh={1.5} mb="spaceLarge" maxw={560}>
          {messages[msgMap[result]].text}
        </FluidBox>
        <NavButton secondary={true} onClick={() => setScreen(dispatch, 'results')}>
          See results
        </NavButton>
      </ContentBox>
    </Root>
  )
}

export default ResultMessage
